// extracted by css-extract-rspack-plugin
export default {"root":"ExpandButton-module__root___Q_C1K","button":"ExpandButton-module__button___vfgco"};